import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Carmen R.',
    age: '46 años',
    result: 'Perdió la hinchazón en 2 semanas',
    text: 'Pensé que mi metabolismo estaba roto para siempre. Hacía dieta y nada. Con este protocolo entendí lo de los picos de glucosa y el estrés. En 14 días mi ropa me queda suelta otra vez y duermo como hace años no lo hacía.',
    image: 'https://i.pravatar.cc/150?img=47'
  }, {
    name: 'Laura M.',
    age: '42 años',
    result: 'Adiós a los sudores nocturnos',
    text: 'Lo compré por desesperación porque no dormía por los bochornos. El pilar del sueño profundo y los ajustes de alimentación cambiaron todo. Es la primera vez que algo me funciona sin sentir que me estoy matando de hambre.',
    image: 'https://i.pravatar.cc/150?img=43'
  }, {
    name: 'Silvia T.',
    age: '51 años',
    result: 'Recuperó su energía y claridad',
    text: "La 'niebla mental' me estaba afectando en el trabajo. Este libro me explicó exactamente por qué pasaba. Los cambios son tan simples que pensé que no funcionarían, pero hoy tengo más energía que a mis 30.",
    image: 'https://i.pravatar.cc/150?img=32'
  }, {
    name: 'Elena G.',
    age: '48 años',
    result: 'Bajó 4 kilos de grasa abdominal',
    text: "Hacía 2 horas de cardio y solo engordaba más de la cintura. Cambiar al 'movimiento inteligente' que explican aquí fue la clave. Menos esfuerzo, más resultados. Totalmente recomendado para mujeres de nuestra edad.",
    image: 'https://i.pravatar.cc/150?img=44'
  }];
  return <section className="py-24 px-4 bg-primary-bg" data-id="element-209">
      <div className="max-w-6xl mx-auto" data-id="element-210">
        <div className="text-center mb-16" data-id="element-211">
          <h2 className="text-4xl sm:text-5xl font-serif font-bold text-text-primary mb-4" data-id="element-212">
            Mujeres reales.{' '}
            <span className="text-accent-dark" data-id="element-213">Cambios reales.</span>
          </h2>
          <p className="text-xl text-text-primary/70" data-id="element-214">
            Únete a cientos de mujeres que ya están recuperando el control de su
            cuerpo.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-215">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-white p-8 rounded-3xl shadow-md border border-text-primary/5 relative" data-id="element-216">
              <div className="flex gap-1 mb-4" data-id="element-217">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} className="fill-accent text-accent" data-id="element-218" />)}
              </div>
              <p className="text-text-primary/80 italic mb-6 text-lg leading-relaxed" data-id="element-219">
                "{testimonial.text}"
              </p>
              <div className="flex items-center gap-4" data-id="element-220">
                <img src={testimonial.image} alt={testimonial.name} className="w-14 h-14 rounded-full object-cover border-2 border-primary-contrast" data-id="element-221" />
                <div data-id="element-222">
                  <h4 className="font-bold text-text-primary" data-id="element-223">
                    {testimonial.name}, {testimonial.age}
                  </h4>
                  <span className="text-sm font-semibold text-health bg-health/10 px-2 py-1 rounded-md inline-block mt-1" data-id="element-224">
                    {testimonial.result}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}